module.exports = __webpack_public_path__ + "img/calc-2.459d61cb.png";